import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { NgBusyModule } from 'ng-busy';
import {
  finalize,
  lastValueFrom,
  Subject,
  Subscription,
  takeUntil,
} from 'rxjs';
import { RestClientService } from 'src/app/_core/services/rest-client.service';
import { UtilitiesService } from 'src/app/_core/services/utilities.service';
import { SessionService } from 'src/app/shared/services/sessionStorage.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [CommonModule, FormsModule, NgBusyModule, MatPaginatorModule],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css',
})
export class UsersComponent implements OnInit {
  private destroy$ = new Subject<void>();

  itemsUser: any[] = [];
  itemToSave: any = {};
  itemToSearch: any = {};
  showModal = false;
  isLoading: boolean = false;
  loading = false;

  itemsPerPage = 5;
  currentPage = 0;
  totalItems: number = 0;
  totalDirections: number = 0;
  itemsDirections : any[] = [];
  itemsRole: any[] = [];
  currentUser: any;
  currentUserId : any;
  activeDropdown: number | string | null = null;

  constructor(
    private router: Router,
    private restClient: RestClientService,
    private utilitiesService: UtilitiesService,
    private localStorage: SessionService,
    private cdr: ChangeDetectorRef
  ) {
     this.currentUser = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );
     this.currentUserId = this.currentUser.id;
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );
    this.resetSearchForm();
    this.getUser();
    this.getDirection()
   // this.getRole();

    this.currentUser = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  validateNumberInput(event: KeyboardEvent): void {
    const allowedKeys = [
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
    ];
  
    if (!allowedKeys.includes(event.key)) {
        event.preventDefault();
    }
  }
  
  validateNumberPaste(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text');
    if (pastedData && !/^\d+$/.test(pastedData)) {
        event.preventDefault();
    }
  }

  getDirection(){
   
       this.isLoading = true;
       const request = {
         isSimpleLoading: false,
         user: this.currentUser.id,
         data: {
           
         },
       };
   
       this.restClient
         .post('directions/getByCriteria', request)
         .pipe(
           takeUntil(this.destroy$),
           finalize(() => {
             this.isLoading = false;
           })
         )
         .subscribe({
           next: (res: any) => {
            //  console.log('Réponse API Users:', res);
             this.totalDirections = res.count;
            //  console.log('totalUser', this.totalDirections);
   
             this.itemsDirections = res?.items?.length > 0 ? res.items : [];
             this.cdr.markForCheck();
           },
           error: (err) => {
             console.error(
               'Erreur lors de la récupération des Directions:',
               err
             );
             this.itemsDirections = [];
           },
         });
   
       this.cdr.markForCheck();

 }
  toggleDropdown(id: number | string): void {
    if (this.activeDropdown === id) {
      this.activeDropdown = null;
    } else {
      this.activeDropdown = id;
    }
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event): void {
    if (!(event.target as HTMLElement).closest('.dropdown')) {
      this.activeDropdown = null;
    }
  }

  openModal(item?: any) {
    this.activeDropdown = null; 
    if (item) {
      this.itemToSave = {
        id: item.id,
        nom: item.nom || '',
        prenoms: item.prenoms || '',
        email: item.email || '',
        fonction: item.fonction || '',
        telephone: item.telephone || '',
        profil: item.profil || '',
        roleId: item.roleId || '',
        isAdmin: item.isAdmin === true,
        directionId: item.direction.id || '',
        typeUser: item.typeUser || 'Responsable',
      };
    } else {
      // Pour l'ajout - réinitialiser avec des valeurs vides
      this.itemToSave = {
        id: null,
        nom: '',
        prenoms: '',
        email: '',
        fonction: '',
        telephone: '',
        roleId: '',

        isAdmin: false,
        directionId:  '',
        typeUser: 'Responsable',
      };
    }
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  pageChanged(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.getUser(false);
    
  }
  

  getRole() {
    console.log('getRole appelé');

    const request = {
      index: this.currentPage,
      size: 100, 
      isSimpleLoading: false,
      user: this.currentUser.id,
      data: {
        libelle: this.itemToSearch.libelle || '',
      },
    };

    this.restClient
      .post('role/getByCriteria', request)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {})
      )
      .subscribe({
        next: (res: any) => {
          console.log('Réponse API role:', res);
          this.itemsRole = res?.items?.length > 0 ? res.items : [];
          this.cdr.markForCheck();
          console.log('itemsRole:', this.itemsRole);
        },
        error: (err) => {
          console.error('Erreur lors de la récupération des rôles:', err);
          this.itemsRole = [];
        },
      });
  }
  

  confirmSave(item: any) {

    if (!item.nom || !item.prenoms || !item.profil || !item.telephone || !item.directionId) {
      this.utilitiesService.showNotification(
        'Veuillez renseigner tous les champs obligatoires.',
        'error'
      );
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!item.email || !emailRegex.test(item.email)) {
      this.utilitiesService.showNotification(
        'Veuillez renseigner un email valide.',
        'error'
      );
      return;
    }

    

    this.loading = true;
    let objToSave = Object.assign({}, item);
  
    const isUpdate = objToSave.id != null;
    const actionText = isUpdate ? 'modifier' : 'enregistrer';
    const textMessage = isUpdate ? 'modifié' : 'enregistré';
    const article = /^[aeiouh]/i.test(actionText) ? "d'" : 'de '; 
    Swal.fire({
      title: 'Utilisateur',
      text: `Vous êtes sur le point ${article}${actionText} un utilisateur. Voulez-vous poursuivre cette action ?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff7900',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        const endpoint = isUpdate ? 'users/update' : 'users/create';
  
        const request = {
          user: this.currentUser.id,
          datas: [objToSave],
        };
  
        this.restClient
          .post(endpoint, request)
          .pipe(
            takeUntil(this.destroy$),
            finalize(() => (this.loading = false, this.cdr.markForCheck()))
          )
          .subscribe({
            next: (res) => {
              if (!res.hasError) {
                this.utilitiesService.showNotification(
                  `Utilisateur ${textMessage} avec succès`,
                  'success'
                );
                this.closeModal();
                this.getUser();
              } else {
                const apiErrorMessage = res.status?.message ||
                  "Une erreur est survenue lors de l'opération";
                this.utilitiesService.showNotification(apiErrorMessage, 'error');
                this.cdr.markForCheck();
              }
            },
            error: (err: HttpErrorResponse) => {
              console.error('Erreur API:', err);
              let errorMessage = "Une erreur s'est produite lors de l'enregistrement de la réunion";
              if (err.error?.status) {
                errorMessage = err.error.status.message;
              } else if (err.error?.message) {
                errorMessage = err.error.message;
              } else if (err.message) {
                errorMessage = err.message;
              }
              this.utilitiesService.showNotification(errorMessage, 'error');
            }
          });
      } else {
        this.loading = false;
      }
    });
  }
  

  resetSearchForm() {
    this.itemToSearch = {
      nom: '',
      roleId: null,
      libelle: '',
    };
  }

  deleteItem(id: number) {
    this.loading = true;
    const request = {
      user: this.currentUser.id ,
      datas: [{ id: id }],
    };

    console.log(request);

    this.restClient.post('users/delete', request).subscribe({
      next: (res) => {
        this.loading = false;
        if (!res.hasError) {
          this.utilitiesService.showNotification(
            'Utilisateur supprimé avec succès',
            'success'
          );
          this.getUser();
        } else {
          this.utilitiesService.showNotification(
            "Une erreur inattendue s'est produite lors de la suppression",
            'error'
          );
        }
      },
      error: (err) => {
        console.error('Erreur:', err);
        this.loading = false;
        this.utilitiesService.showNotification(
          "Une erreur inattendue s'est produite",
          'error'
        );

        this.cdr.markForCheck();
      },
    });
  }

  confirmDelete(id: number) {
    Swal.fire({
      title: 'Confirmation',
      text: 'Voulez-vous vraiment supprimer cet utilisateur ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f97316',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteItem(id);
      }
    });
  }

  // getUser() {
  //   if (this.isLoading) return;

  //   this.isLoading = true;
  //   const request = {
  //       index: this.currentPage,
  //       size: this.itemsPerPage,
  //     isSimpleLoading: false,
  //     user: this.currentUser.id,
  //     data: {
  //       nom: this.itemToSearch.nom || '',
  //       prenoms: this.itemToSearch.prenoms || '',
  //     },
  //   };

  //   this.restClient
  //     .post('users/getByCriteria', request)
  //     .pipe(
  //       takeUntil(this.destroy$),
  //       finalize(() => {
  //         this.isLoading = false;
  //       })
  //     )
  //     .subscribe({
  //       next: (res: any) => {
  //         console.log('Réponse API Users:', res);
  //         this.totalItems = res.count;
  //         console.log('totalUser', this.totalItems);

  //         this.itemsUser = res?.items?.length > 0 ? res.items : [];
  //         this.cdr.markForCheck();
  //       },
  //       error: (err) => {
  //         console.error(
  //           'Erreur lors de la récupération des utilisateurs:',
  //           err
  //         );
  //         this.itemsUser = [];
  //       },
  //     });

  //   this.cdr.markForCheck();
  // }

  getUser(resetPagination: boolean = false) {
  if (this.isLoading) return;

  this.isLoading = true;

  // Réinitialiser la pagination si demandé OU si on fait une recherche
  if (resetPagination || this.isSearching()) {
    this.currentPage = 0; 
  }

  const request: any = {
    index: this.currentPage,
    size: this.itemsPerPage,
    isSimpleLoading: false,
    user: this.currentUser.id,
    data: {
      nom: this.itemToSearch.nom || '',
      prenoms: this.itemToSearch.prenoms || '',
    },
  };

  this.restClient
    .post('users/getByCriteria', request)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.isLoading = false;
        this.cdr.markForCheck();
      })
    )
    .subscribe({
      next: (res: any) => {
        // console.log('Réponse API Users:', res);
        this.totalItems = res.count;
        // console.log('totalUser', this.totalItems);

        this.itemsUser = res?.items?.length > 0 ? res.items : [];
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error(
          'Erreur lors de la récupération des utilisateurs:',
          err
        );
        this.itemsUser = [];
        this.cdr.markForCheck();
      },
    });
}

// Méthode pour détecter si une recherche est en cours
private isSearching(): boolean {
  return !!(
    this.itemToSearch?.nom?.trim() ||
    this.itemToSearch?.prenoms?.trim()
  );
}

// Méthode pour lancer une recherche
onSearch() {
  this.getUser(true);
}
  formatRoleFonction(item: {
    roleLibelle?: string;
    fonction?: string;
  }): string {
    const role = item.roleLibelle || '';
    const fonction = item.fonction || '';

    if (role && fonction) {
      return `${role}/${fonction}`;
    }
    if (role) {
      return role;
    }
    if (fonction) {
      return fonction;
    }
    return '-';
  }

  lockUser(user: any) {
    const previousState = user.isLocked;

    user.isLocked = true;

    const payload = {
      user: this.currentUser.id,
      data: {
        id: user.id,
      },
    };

    this.restClient.post('users/toggleLock', payload).subscribe({
      next: () => {
        this.utilitiesService.showNotification(
          "L'utilisateur a été verrouillé avec succès",
          'success'
        );

        this.getUser();
      },
      error: (err) => {
        user.isLocked = previousState;
        this.utilitiesService.showNotification(
          "Échec du verrouillage de l'utilisateur",
          'error'
        );
        this.cdr.markForCheck();
        console.error('Erreur lors du verrouillage:', err);
      },
    });
  }

  async confirmStatut(user: any) {
    
    this.loading = true;
this.activeDropdown = null; 
    try {
      const shouldLock = user?.isLocked !== true;
      const actionText = shouldLock ? 'verrouiller' : 'déverrouiller';

      const result = await Swal.fire({
        title: 'Utilisateur',
        text: `Vous êtes sur le point de ${actionText} cet utilisateur. Voulez-vous poursuivre cette action ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ff7900',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
      });

      if (!result.isConfirmed) {
        this.loading = false;
        return;
      }

      const endpoint = 'users/toggleLock';
      const payload = {
        user: this.currentUser.id ,
        data: {
          id: user.id,

          isLocked: shouldLock,
        },
      };

      const response = await lastValueFrom(
        this.restClient.post(endpoint, payload).pipe(
          takeUntil(this.destroy$),
          finalize(() => (this.loading = false))
        )
      );

      if (!response.hasError) {
        this.utilitiesService.showNotification(
          `Utilisateur ${actionText} avec succès`,
          'success'
        );
        this.getUser();
      } else {
        this.utilitiesService.showNotification(
          `Une erreur s'est produite lors de ${actionText} l'utilisateur`,
          'error'
        );

        this.cdr.markForCheck();
      }
    } catch (error) {
      this.loading = false;
      console.error('Erreur:', error);
      this.utilitiesService.showNotification(
        "Une erreur inattendue s'est produite",
        'error'
      );
    }
  }

  unlockUser(user: any) {
    const previousState = user.isLocked;

    user.isLocked = false;

    const payload = {
      user: this.currentUser,
      data: {
        id: user.id,
      },
    };
    this.restClient.post('users/verrouillerUtilisateur', payload).subscribe({
      next: () => {
        this.utilitiesService.showNotification(
          "L'utilisateur a été déverrouillé avec succès",
          'success'
        );
        this.getUser();
      },
      error: (err) => {
        user.isLocked = previousState;
        this.utilitiesService.showNotification(
          "Échec du déverrouillage de l'utilisateur",
          'error'
        );

        this.cdr.markForCheck();
        console.error('Erreur lors du déverrouillage:', err);
      },
    });
  }

  renitialiserMdp(user: any) {
    this.activeDropdown = null; 
    const payload = {
      user: this.currentUser.id,
      data: {
        //email: user.email,
        id: user.id,
      },
    };

    this.restClient.post('users/resetPassword', payload).subscribe({
      next: () => {
        this.utilitiesService.showNotification(
          'Email de réinitialisation envoyé avec succès',
          'success'
        );
      },
      error: (err) => {
        this.utilitiesService.showNotification(
          "Échec de l'envoi de l'email de réinitialisation",
          'error'
        );

        this.cdr.markForCheck();
        console.error(
          'Erreur lors de la réinitialisation du mot de passe:',
          err
        );
      },
    });
  }
}
